import { CasinoMessageChannels } from "../message";
export const QueryTypes = CasinoMessageChannels;
//# sourceMappingURL=casino.js.map